import addToCartReducer from "./AddToCartReducer";
import authenticationReducer from "./AuthenticationReducer";

const rootReducers = { basket: addToCartReducer, user: authenticationReducer };

export default rootReducers;
